import React from 'react';
import './SingleArtist.css';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { useParams } from 'react-router-dom';
import { Artists } from '../../app/constants/Artists';

const SingleArtist: React.FC = () => {
  const settings = {
    dots: false,
    infinite: false,
    arrows: true, 
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    centerPadding: '5%',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          arrows: true, 
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: true, 
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true, 
        },
      },
    ],
  };

  const { id } = useParams()

  const artist = Artists.find(artist => artist.name === id)!;
  console.log(artist.id)


  const renderMediaLink = (mediaLink: string) => {
    switch (mediaLink) {
      case 'soundcloud':
        return (
          <img src="/images/global/soundcloud.svg" alt="" />
        );
      case 'instagram':
        return (
          <img src="/images/global/instagram.svg" alt="" />
        )
      case 'bandcamp':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none">
                <path
                  d="M33 1.03125C15.3398 1.03125 1.03125 15.3398 1.03125 33C1.03125 50.6602 15.3398 64.9688 33 64.9688C50.6602 64.9688 64.9688 50.6602 64.9688 33C64.9688 15.3398 50.6602 1.03125 33 1.03125ZM39.2133 43.0676H15.8812L26.7996 22.9453H50.1316L39.2133 43.0676Z"
                  fill="white"
                />
              </svg>
        )
      case 'spotify':
        return (
          <svg xmlns="http://www.w3.org/2000/svg" width="66" height="66" viewBox="0 0 66 66" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M2.35693 33C2.35693 24.873 5.58537 17.0789 11.332 11.3323C17.0787 5.58561 24.8728 2.35718 32.9998 2.35718C41.1268 2.35718 48.9209 5.58561 54.6676 11.3323C60.4142 17.0789 63.6427 24.873 63.6427 33C63.6427 41.127 60.4142 48.9212 54.6676 54.6678C48.9209 60.4145 41.1268 63.6429 32.9998 63.6429C24.8728 63.6429 17.0787 60.4145 11.332 54.6678C5.58537 48.9212 2.35693 41.127 2.35693 33ZM24.3208 45.2289C28.8624 44.1652 33.6301 44.6669 37.8508 46.6526C38.2006 46.8182 38.5796 46.9133 38.9661 46.9324C39.3526 46.9516 39.7391 46.8944 40.1036 46.7642C40.468 46.6339 40.8032 46.4332 41.0901 46.1734C41.3769 45.9136 41.6098 45.5999 41.7754 45.2501C41.941 44.9003 42.0361 44.5213 42.0553 44.1348C42.0744 43.7483 42.0172 43.3618 41.887 42.9973C41.7568 42.6329 41.556 42.2977 41.2962 42.0108C41.0365 41.724 40.7227 41.4911 40.3729 41.3255C34.9477 38.7681 28.8172 38.1202 22.9772 39.4869C22.6002 39.5751 22.2442 39.7367 21.9297 39.9625C21.6151 40.1883 21.3481 40.4738 21.1439 40.8028C20.9397 41.1318 20.8022 41.4978 20.7395 41.8799C20.6767 42.2619 20.6898 42.6527 20.778 43.0297C20.8662 43.4067 21.0278 43.7627 21.2536 44.0772C21.4794 44.3918 21.7649 44.6588 22.0939 44.863C22.4229 45.0672 22.7889 45.2047 23.171 45.2674C23.5531 45.3302 23.9438 45.3171 24.3208 45.2289ZM29.0398 35.2582C26.6544 35.2582 24.3349 35.5363 22.1192 36.0596C21.7425 36.1484 21.352 36.1622 20.9699 36.1001C20.5879 36.038 20.2218 35.9013 19.8926 35.6978C19.5634 35.4942 19.2776 35.2278 19.0513 34.9137C18.8251 34.5997 18.6629 34.2442 18.5741 33.8675C18.4852 33.4907 18.4715 33.1002 18.5336 32.7182C18.5956 32.3361 18.7324 31.9701 18.9359 31.6409C19.1395 31.3117 19.4059 31.0258 19.7199 30.7996C20.034 30.5733 20.3895 30.4112 20.7662 30.3223C29.0258 28.3769 37.707 29.4086 45.2805 33.2358C45.973 33.5916 46.4965 34.207 46.7366 34.9476C46.9768 35.6882 46.914 36.4938 46.5621 37.1882C46.2102 37.8827 45.5977 38.4097 44.8585 38.654C44.1193 38.8983 43.3134 38.8402 42.6169 38.4922C38.4095 36.3588 33.7572 35.2507 29.0398 35.2582ZM19.8941 26.895C22.8908 26.1855 25.9602 25.8279 29.0398 25.8296C35.7152 25.8296 41.9947 27.4796 47.5009 30.4025C48.1917 30.7682 48.9995 30.8445 49.7466 30.6146C50.4936 30.3848 51.1188 29.8675 51.4845 29.1768C51.8502 28.486 51.9265 27.6782 51.6967 26.9311C51.4668 26.184 50.9496 25.5589 50.2588 25.1932C43.724 21.7317 36.4395 19.9268 29.0445 19.9368C25.5045 19.9349 21.9763 20.3463 18.5316 21.1625C18.1505 21.2473 17.79 21.407 17.4711 21.6324C17.1522 21.8578 16.8813 22.1443 16.6741 22.4753C16.4669 22.8063 16.3276 23.1752 16.2643 23.5605C16.2009 23.9458 16.2148 24.3399 16.3051 24.7198C16.3954 25.0997 16.5603 25.4579 16.7902 25.7735C17.0202 26.0892 17.3105 26.3559 17.6445 26.5583C17.9784 26.7607 18.3493 26.8947 18.7355 26.9525C19.1217 27.0103 19.5155 26.9908 19.8941 26.895Z"
              fill="white"
            />
          </svg>
        )
    }
  };

  return (
    <main>
      <section id="artist-banner">
        <div className="artist-banner container">
          <div className="overlay"></div>
          <div className="artist-img">
            <img className='w-100' src={artist.image} alt="" />
          </div>
          {/* <div className="artist-label">
            {artist.tags!.map((x, i) =>
              <p key={i}>{x}</p>
            )}
          </div> */}
          <div className="artist-links">
            {artist.mediaLinks.map((mediaLink, i) => (
              <a href={mediaLink.link} key={i} target="_blank" rel="noreferrer">
                {renderMediaLink(mediaLink.type)}
              </a>
            ))}
          </div>
          <div className={`artist-name ${artist.name === 'Your friend, daao' ? 'artist-name--small' : ''}`}>
            <p>{artist.name}</p>
          </div>
        </div>
      </section>
      <section>
        <div className="about-artist flex flex--direction__column gap-3 flex--align-center">
          <div className="flex flex--start gap-20">
            <div>
              <p>About</p>
            </div>
            <div>
              <span>
                {artist.longBio}
              </span>
            </div>
          </div>
          {
            artist.podcasts!.length > 0 && 
            <div className="flex flex--start gap-20 w-100">
              <div>
                <p>Recent Podcasts</p>
              </div>
              <div>
                <span>
                  {/* Yhii is a DJ and producer from the heart of Yerevan and a founder of Back&forth, resident artist at Poligraf club (closed now) and DIARIES
                  collective. */}
                </span>
              </div>
            </div>
          }
        </div>
      </section>
      <div className="media-container">
        <section id="soundcloud-list">
          <div className="flex slider-container flex--space-between gap-2 ">
            <Slider {...settings} arrows={artist.podcasts.length>3}>
              {artist.podcasts!.map((x, i) =>
                  <div className="soundcloud-list" key={i}>
                    <iframe
                      width="100%"
                      height="330"
                      scrolling="no"
                      frameBorder="no"
                      allow="autoplay"
                      title="1"
                      src={x}
                    ></iframe>
                    {/* <div>
                      <a href="https://soundcloud.com/backand-forth" title="Back&amp;forth" target="_blank" rel="noreferrer">
                        Back&amp;forth
                      </a>{' '}
                      ·
                      <a href="https://soundcloud.com/backand-forth/backforth-podcast-03-kazmir00" title="Back&amp;forth Podcast 03: kazmir00" target="_blank" rel="noreferrer">
                        Back&amp;forth Podcast 03: kazmir00
                      </a>
                    </div> */}
                  </div>
                )}
            </Slider>
          </div>
        </section>
        {
          artist.videoPodcasts!.length > 0 && 
          <section>
            <div className="video-text flex flex--start gap-20">
              <p className="space-nowrap">Video Podcasts</p>
              <span>
                Yhii is a DJ and producer from the heart of Yerevan and a founder of Back&forth, resident artist at Poligraf club (closed now) and DIARIES
                collective.
              </span>
            </div>
          </section>
        }
        {
          artist.videoPodcasts!.length > 0 &&
          <section>
            <div className="flex flex--space-between gap-2">
              <Slider {...settings}>
                {artist.videoPodcasts!.map((x, i) =>
                  <div className="video-list" key={i}>
                    <iframe
                      width="100%"
                      height="330"
                      src={x}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen />
                  </div>
                )}
              </Slider>
            </div>
          </section>
        }
        
      </div>
    </main>
  );
};

export default SingleArtist;
